import { forwardRef } from 'react';
import type { InputHTMLAttributes, ReactNode, SelectHTMLAttributes, TextareaHTMLAttributes } from 'react';

const fieldClasses =
  'w-full px-3 py-2 rounded-lg text-[13px] outline-none bg-surface-muted border border-border text-ink transition-colors duration-150 hover:border-primary-200 focus:bg-white focus:border-primary-400 focus:ring-2 focus:ring-primary-100';

export function Field({ label, children }: { label?: string; children: ReactNode }) {
  return (
    <div>
      {label && <label className="block text-[11px] font-semibold mb-1.5 text-ink-faint tracking-wide">{label}</label>}
      {children}
    </div>
  );
}

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className = '', ...rest }, ref) => <input ref={ref} className={`${fieldClasses} ${className}`} {...rest} />,
);
Input.displayName = 'Input';

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement>>(
  ({ className = '', ...rest }, ref) => <textarea ref={ref} className={`${fieldClasses} ${className}`} {...rest} />,
);
Textarea.displayName = 'Textarea';

export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  ({ className = '', ...rest }, ref) => <select ref={ref} className={`${fieldClasses} ${className}`} {...rest} />,
);
Select.displayName = 'Select';
